// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#home-for-other-office-service[data-v-500ff17b]{max-width:1280px;margin-left:auto;margin-right:auto}#home-for-other-office-service .other-office-base-info[data-v-500ff17b]{margin-left:-3px;margin-right:-3px}#home-for-other-office-service .other-office-base-info .home-box[data-v-500ff17b]{padding-left:3px;padding-right:3px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
